export const apiRequestForMenu = endpoint => {
    return new Promise((resolve, reject) => {
        fetch(`https://www.admin.rossnoble.com/wp/wp-json/wp-api-menus/v2/${endpoint}`)
            .then(resp => resp.json())
            .then(resolve)
            .catch(reject);
    });
} 

// sedhal added
export const apiRequest = endpoint => {
    return new Promise((resolve, reject) => {
        fetch(`https://www.admin.rossnoble.com/wp/wp-json/wp/v2/${endpoint}`)
            .then(resp => resp.json())
            .then(resolve)
            .catch(reject);
    });
}



// WEBPACK FOOTER //
// ./src/services.js